  <template>
  <div class="l-row--t128 module credit" v-show="data.option">
    <div class="i--creditEdit"></div>
    <div class="l-row--t128 module c-sep">
      <div class="g-row l-mdl--8 ">
        <div class="g-col--6 g-col--2s">
          <div class="t-h--13 t-h--11s"><span class="t--fak">{{ data.brand }} <span class="t--ft">(</span>{{ data.type }}<span class="t--ft">)</span></span></div>
        </div>
        <div class="g-col--6 g-col--3s">
          <div class="t-h--13 t-h--11s"><span class="t--fak">{{ data.client.name }}</span></div>
        </div>
      </div>
    </div>

    <div class="l-mdl--32 g-row credit__tit">
      <div class="g-col--15 g-col--5s">
        <div class="t-h--128 t-h--54s t-h--200l s--left credit__tit-first">
          <span class="t--fak">Thanks for</span>
        </div>
        <div class="t-h--128 t-h--54s t-h--200l s--right credit__tit-second">
          <span class="t--fak"><em class="c-spacer c-spacer--thumb">
            <template v-if="methods.isThumbnailType() ==='mp4'">
              <video class="credit__video" loop autoplay playsinline preload="auto" oncontextmenu="return false">
                <source :src="data.thumbnail" type="video/mp4">
              </video>
            </template>
            <template v-else>
              <img :src="data.thumbnail" alt="">
            </template>
            </em>Watching</span>
        </div>
      </div>
    </div>
    <div class="l-mdl--32 g-row credit__item-wrap s--h-start">
      <div class="g-col--6 g-col--2s">
        <div class="credit__item">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="data.client.name !== ''">(</span><span v-if="data.client.name !== ''">Client</span><span class="t--ft" v-if="data.client.name !== ''">)</span></span>
            </div>
            </div>
            <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak">{{data.client.name}}<span class="t--ft" v-if="data.client.link !== ''">(</span><a :href="data.client.link" target='_blank' v-if="data.client.link !== ''">↗</a>
              <span class="t--ft" v-if="data.client.link !== ''">)</span></span>
            </div>
          </div>
        </div>
        <div class="credit__item" v-for="(item, idx) in data.agency" :key="idx">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="item.caption !== ''">(</span>{{item.caption}}<span class="t--ft" v-if="item.caption !== ''">)</span></span>
            </div>
          </div>
          <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak">
                <span v-html="methods.alignAgency(item.items)"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="g-col--6 g-col--3s">
        <div class="credit__item" v-for="(item, idx) in data.plan" :key="idx">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="item.caption !== ''">(</span>{{item.caption}}<span class="t--ft" v-if="item.caption !== ''">)</span></span>
            </div>
          </div>
          <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak"><span v-html="methods.alignNames(item.items)"></span></span>
            </div>
          </div>
        </div>
        <div class="credit__item" v-for="(item, idx) in data.design" :key="idx">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="item.caption !== ''">(</span>{{item.caption}}<span class="t--ft" v-if="item.caption !== ''">)</span></span>
            </div>
          </div>
          <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak"><span v-html="methods.alignNames(item.items)"></span></span>
            </div>
          </div>
        </div>
        <div class="credit__item" v-for="(item, idx) in data.contents" :key="idx">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="item.caption !== ''">(</span>{{item.caption}}<span class="t--ft" v-if="item.caption !== ''">)</span></span>
            </div>
          </div>
        <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak"><span v-html="methods.alignNames(item.items)"></span></span>
            </div>
        </div>
        </div>
        <div class="credit__item" v-for="(item, idx) in data.develop" :key="idx">
          <div class="credit__cat">
            <div class="t-h--13 t-h--11s">
              <span class="t-block t--fak"><span class="t--ft" v-if="item.caption !== ''">(</span>{{item.caption}}<span class="t--ft" v-if="item.caption !== ''">)</span></span>
            </div>
          </div>
          <div class="credit__name">
            <div class="t-h--16 t-h--13s">
              <span class="t-block t--fak"><span v-html="methods.alignNames(item.items)"></span></span>
            </div>
          </div>
        </div>
        <div class="l-mdl--32 credit__year">
          <div class="t-h--16 t-h--13s">
            <span class="t--fak">©{{methods.getLaunchingYear()}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="g-col--6 g-col--3s g-ml--6  g-ml--2s s--h-end">
        <div class="l-mdl--32 credit__year">
          <div class="t-h--16 t-h--13s">
            <span class="t--fak">©{{methods.getLaunchingYear()}}</span>
          </div>
        </div>
      </div> -->
      <Minime
        :position="[-30, 26, 'auto', 'auto']"
        :position-mo="[-80, 0, 'auto', 'auto']"
        :position-pc="[-20, 96, 'auto', 'auto']"
      />
    </div>
  </div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { computed, ref, reactive, useStore, onMounted } from "@/helper/vue.js";
import { formatYear, getDate } from "@/helper/gadget.js";
import Picture from "@/parts/picture/PictureView.vue";
import Giphy from "@/parts/giphy/Giphy.vue";
import Minime from "@/parts/minime/Minime.vue";
export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture,
    Giphy,
    Minime
	},
  setup(props) {
    const { state, get, commit, dispatch } = useStore();
		const self = ref();
		const data = reactive({
      brand: computed(() => get["from"](`${props.bindRoot}.brand`)),
      type: computed(() => get["from"](`${props.bindRoot}.type`)),
      client: computed(() => get["from"](`${props.bindRoot}.client`)),
      option: computed(() => get["from"](`${props.bindRoot}.options.credit`)),
			agency: computed(() => get["from"](`${props.bindRoot}.memberSet.agency`)),
      plan: computed(() => get["from"](`${props.bindRoot}.memberSet.plan`)),
      design: computed(() => get["from"](`${props.bindRoot}.memberSet.design`)),
      contents: computed(() => get["from"](`${props.bindRoot}.memberSet.contents`)),
      develop: computed(() => get["from"](`${props.bindRoot}.memberSet.develop`)),
      launching: computed(() => get["from"](`${props.bindRoot}.launching`)),
      thumbnail: computed(() => get["from"](`${props.bindRoot}.thumbnail`)),
		})
    const methods = {
      alignAgency(data) {
        const engNames = data.map(i => i[1]);
        const getDFY = engNames.filter(i => i == 'DFY')

        if (engNames.length < 3) {
          if (engNames.length == 1 && getDFY.length) {
            return '<span class="t-dfy">' + engNames[0] + '</span>'
          } else if (!getDFY.length) {
            let joinWith = ' & ';
            return engNames.join(joinWith)
          } else {
            return '<span class="t-dfy">' + engNames[0] + '</span>' + ' & ' + engNames[1]
          } 
        }
        // 에이전시 이름 여러 개인 경우
        const multiNames = engNames.map((name, idx) => {
          // 첫번쨰 데이터가 'DFY'인 경우 t-dfy 클래스 추가
          if (idx == 0 && getDFY.length) {
            return '<span class="t-dfy">' + name + '</span>' + "<span class='t-wsp'>" + '<span class="t--ft"> /</span>' + '</span>'
          }
          // 마지막 데이터 ' /' 구분 분기
          if (engNames.length !== idx + 1) {
            return "<span class='t-wsp'>" + name + '<span class="t--ft"> /</span>' + '</span>'
          } else {
            return "<span class='t-wsp'>" + name + '</span>'
          }
        })
        return multiNames.join(' ');
      },
      alignNames(data) {
        const engNames = data.map(i => i[1]);
        if (engNames.length < 3) {
          let joinWith = ' & ';
          return engNames.join(joinWith)
        } 
        const multiNames = engNames.map((name, idx) => {
          if (engNames.length !== idx + 1) {
            return "<span class='t-wsp'>" + name + '<span class="t--ft"> /</span>' + '</span>'
          } else {
            return "<span class='t-wsp'>" + name + '</span>'
          }
        })
        return multiNames.join(' ');
      },
      getLaunchingYear() {
        return formatYear(getDate(data.launching.toString()).year)
      },
      isThumbnailType() {
        const fileLength = data.thumbnail.length
        const lastDot = data.thumbnail.lastIndexOf('.')
        const type = data.thumbnail.substring(lastDot + 1, fileLength).toLowerCase()
        return type
      }
    }
    onMounted (() => {
    })
    return {
			self,
			data,
      methods
    };
  },
};
</script>

<style scoped lang="scss">
.credit {
  margin-bottom: 256em;
	&__tit {
    // justify-content: flex-end;
    &-first {
      margin-left: 0.7em;
    }
    &-second {
      margin-left: 216em;
      // margin-left: 159em;
      .c-spacer  {
        display: inline-flex;
        margin-left: -0.062em;
        width: inherit;
        max-width: 0.99em;
        img, video {
          object-fit: scale-down;
        }
      }
      .__w600 & {
        margin-left: 0;
        text-align: left;
      }
      .w1600__ & {
        margin-left: 260em;
      }
    }
	}
  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
	&__item {
		margin-top: 32em;
    align-items: baseline;
    .__w600 & {
      margin-top: 16em;
      &:last-child {
        margin-bottom: 16em;
      }
    }
		&:first-child {
			margin-top: 0;
		}
		&-wrap {
      position: relative;
			text-transform: uppercase;
			font-feature-settings: 'case' on, 'salt' on;
		}
	}
	&__cat {
		// text-align: right;
		padding-right: 1.5em;
	}
	&__name {
		text-align: left;
	}
	&__pic {
		.__w600 & {
			display: none;
		}
	}
	&__year {
		/* justify-content: flex-end; */
	}
  .i--creditEdit {
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>